import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: solid 2px var(--text);
  padding: 50px 40px;
  border-radius: 10px;
  text-align: center;
`;

export const FormTitle = styled.h2`
  margin: 0;
  font-size: 1.8rem;
  margin-bottom: 6px;
`;
